import React, { useContext, useEffect, useState } from "react";
import RequestBarChart from "./RequestBarChart";
import SettlementRequest from "./SettlementRequest";
import CanvasJSReact from "@canvasjs/react-charts";
import SelectForm from "../../Components/SelectForm/SelectForm";
import "./innerSettlement.css";
import { GetMultipleDropdownData } from "../../Helpers/APIEndPoints/EndPoints";
import { APICall } from "../../Helpers/Network/APICalls";
import { DropdownTypeId } from "../../Helpers/Enums/DropdownTypeId";
import { ApiStatus } from "../../Helpers/Enums/ApiStatus";
import {
  GetLoanRequestPieChartDetails,
  GetSettlementPieChartDetails,
  GetBarGraphDetailsForSettlement,
} from "../../Helpers/APIEndPoints/EndPoints";
import moment from "moment";
import { LoaderContext, getContext } from "../../Helpers/Context/Context";
import notify from "../../Helpers/ToastNotification";
import { RoleEnum } from "../../Helpers/Enums/RoleEnum";
import { round } from "lodash";

const InnerSettlementRequest = () => {
  const [pendingSettlement, setPendingSettlement] = useState<any>();
  const [approvedSettlement, setApprovedSettlement] = useState<any>();
  const [rejectedSettlement, setRejectedSettlement] = useState<any>();
  const [pendingLoan, setPendingLoan] = useState<any>();
  const [approvedLoan, setApprovedLoan] = useState<any>();
  const [rejectedLoan, setRejectedLoan] = useState<any>();
  const [settlementMonth, setSettlementMonth] = useState<any>({
    value: moment().format("MMMM"),
    label: moment().format("MMMM"),
  });
  const [settlementYear, setSettlementYear] = useState<any>({
    value: moment().year(),
    label: moment().year(),
  });
  const [loaMonth, setLoaMonth] = useState<any>({
    value: moment().format("MMMM"),
    label: moment().format("MMMM"),
  });
  const [loanYear, setLoanYear] = useState<any>({
    value: "2024",
    label: "2024",
  }); // moment().year(),  moment().year()
  const [typeofApplicant, setTypeofApplicant] = useState<any>(null);
  const [typeofApplicantOptions, setTypeofApplicantOptions] = useState<any>([]);
  const [loandataAvailable, setLoandataAvailable] = useState(true);
  const [stlmtdataAvailable, setStlmtdataAvailable] = useState(true);
  const [TotalApplications, setTotalApplications] = useState("");
  const [JanData, setJanData] = useState(50);
  const [FebData, setFebData] = useState(56);
  const [MarchData, setMarchData] = useState(60);
  const [AprilData, setAprilData] = useState(80);
  const [MayData, setMayData] = useState(120);
  const [JuneData, setJuneData] = useState(250);
  const [Julyata, setJulyata] = useState(100);
  const [AugData, setAugData] = useState(200);
  const [SepData, setSepData] = useState(750);
  const [OctData, setOctData] = useState(356);
  const [NevData, setNevData] = useState(400);
  const [DecData, setDecData] = useState(290);

  const context = getContext();

  const { showLoader, hideLoader } = useContext(LoaderContext);
  const { Roles, loggedInAs, CurrentRoleId } = context;
  const [month, setMonth] = useState(null);
  const [year, setYear] = useState(null);

  // State variables to manage loading and data
  const [isLoading, setIsLoading] = useState(false); 
  const [hasData, setHasData] = useState(true); 

  let monthOption = [
    { value: "01", label: "Jan" },
    { value: "02", label: "Feb" },
    { value: "03", label: "March" },
    { value: "04", label: "April" },
    { value: "05", label: "May" },
    { value: "06", label: "June" },
    { value: "07", label: "July " },
    { value: "08", label: "August" },
    { value: "09", label: "September" },
    { value: "10", label: "October" },
    { value: "11", label: "November" },
    { value: "12", label: "December" },
  ];

  let yearOption = [
    { value: "01", label: "2015" },
    { value: "02", label: "2016" },
    { value: "03", label: "2017" },
    { value: "04", label: "2018" },
    { value: "05", label: "2019" },
    { value: "06", label: "2020" },
    { value: "07", label: "2021 " },
    { value: "08", label: "2022" },
    { value: "09", label: "2023" },
    { value: "10", label: "2024" },
    { value: "11", label: "2025" },
    { value: "12", label: "2026" },
  ];

  const getMultipleDropdownData = async () => {
    const requestBody = {
      dropdowns: [
        {
          dropdownName: "generic",
          GenericMasterTypeId: DropdownTypeId.ApplicantType,
        },
      ],
    };

    const result = await APICall(GetMultipleDropdownData, requestBody);
    if (result && result.Status === ApiStatus.OK) {
      let mdData = result.Data[0].Data;
      let options = mdData.map((item) => {
        return {
          value: item.value,
          label: item.label,
          code: item.code,
        };
      });
      setTypeofApplicantOptions(options);
    }
  };

  const GetLoanRequestChartDetails = async (year, month) => {
     
    if (year !== "" && month !== "") {
      showLoader();
      const requestparam = {
        MemberId: context.MemberId,
        Year: year,
        Month: month,
        IsAdmin: true,
      };

      const LoanChatData = await APICall(
        GetLoanRequestPieChartDetails,
        requestparam
      );
      console.log("loan chart data=");
      console.log(LoanChatData);
      if (LoanChatData.Data && LoanChatData.Data.length > 0) {
        hideLoader();
        setLoandataAvailable(true);
        const totalRequests = LoanChatData.Data.length;
        const pendingData = LoanChatData.Data?.filter(
          (item) => item.Status === "Pending"
        );
        const pendingCount = pendingData.length;
        const pendingPercentage = round((pendingCount / totalRequests) * 100,2);
        
        

        const approvedData = LoanChatData.Data?.filter(
          (item) => item.Status === "Approved"
        );
        const approvedCount = approvedData.length;
        const approvedPercentage =round( (approvedCount / totalRequests) * 100,2);

        const rejectedData = LoanChatData.Data?.filter(
          (item) => item.Status === "Rejected"
        );
        const rejectedcount = rejectedData.length;
        const rejectedPercentage =  round((rejectedcount / totalRequests) * 100,2);

        setPendingLoan(pendingPercentage);
        setApprovedLoan(approvedPercentage);
        setRejectedLoan(rejectedPercentage);
        // LoanRequestChart();
      } else {
        // notify(1,"No Data available for the current month and year");
        hideLoader();
        setPendingLoan(0);
        setApprovedLoan(0);
        setRejectedLoan(0);
        setLoandataAvailable(false);
        console.log("Data is empty");
      }
    } else {
      console.log("month and yeare are required");
    }
  };

  const GetSettlementRequestChartDetails = async (year, month) => {

    if (year !== "" && month !== "") {
      showLoader();
      const requestparam = {
        MemberId: context.MemberId,
        Year: year,
        Month: month,
        IsAdmin: true,
      };
      const settlementChartData = await APICall(
        GetSettlementPieChartDetails,
        requestparam
      );
      console.log("settlementChartData=");
      console.log(settlementChartData);
      if (settlementChartData.Data && settlementChartData.Data.length > 0) {
        hideLoader();
        setStlmtdataAvailable(true);
        const stlmttotalRequests = settlementChartData.Data.length;
        const stlmtpendingData = settlementChartData.Data?.filter(
          (item) => item.Status === "Pending"
        );
        const stlmtpendingCount = stlmtpendingData.length;
        const stlmtpendingPercentage =
          (stlmtpendingCount / stlmttotalRequests) * 100;

        const stlmtapprovedData = settlementChartData.Data?.filter(
          (item) => item.Status === "Approved"
        );
        const stlmtapprovedCount = stlmtapprovedData.length;
        const stlmtapprovedPercentage =
          (stlmtapprovedCount / stlmttotalRequests) * 100;

        const stlmtrejectedData = settlementChartData.Data?.filter(
          (item) => item.Status === "Rejected"
        );
        const stlmtrejectedcount = stlmtrejectedData.length;
        const stlmtrejectedPercentage =
          (stlmtrejectedcount / stlmttotalRequests) * 100;
        console.log("stlmtpendingCount=" + stlmtpendingCount);
        console.log("stlmtpendingPercentage=" + stlmtpendingPercentage);
        setPendingSettlement(stlmtpendingPercentage);
        setApprovedSettlement(stlmtapprovedPercentage);
        setRejectedSettlement(stlmtrejectedPercentage);
        // SettlementRequestChart();
      } else {
        // notify(1,"No Data available for the current month and year");
        hideLoader();
        setStlmtdataAvailable(false);
        setPendingSettlement(0);
        setApprovedSettlement(0);
        setRejectedSettlement(0);

        console.log("Data is empty");
      }
    } else {
      hideLoader();
      console.log("month and yeare are required");
    }
  };

  // Bar Chart API
  const GetBarChartDetails = async () => {
    setIsLoading(true); // Show loader
    showLoader();
    const requestparam = {
      MemberId: context.MemberId,
      IsAdmin: loggedInAs?.value === RoleEnum.Admin ? true : false,
      TotalApplications: TotalApplications,
    };
  
    try {
      const settlementBarChartData = await APICall(GetBarGraphDetailsForSettlement, requestparam);
  
      if (settlementBarChartData?.Data && settlementBarChartData.Data.length > 0) {
        const monthlyData = {};
  
        // Process data and aggregate by month
        settlementBarChartData.Data.forEach((data) => {
          const month = parseInt(data.Month); // Convert month to integer
          if (!monthlyData[month]) {
            monthlyData[month] = 0; // Initialize total for the month
          }
          monthlyData[month] += parseInt(data.TotalApplications || 0); // Handle null TotalApplications
        });
  
        const months = Object.keys(monthlyData); // Extract months
        const totalApplications = Object.values(monthlyData); // Extract total applications
        const highestcount = settlementBarChartData.Data[0]?.HighestCount || 0;
  
        initializeBarChart(months, totalApplications, highestcount);
        setHasData(true); // Data available
      } else {
        setHasData(false); // No data available
        initializeBarChart([], [], 0); // Render an empty chart
      }
    } catch (error) {
      console.error("Error fetching bar chart details:", error);
      setHasData(false); // Handle error by showing an empty chart
      initializeBarChart([], [], 0);
    } finally {
      hideLoader();
      setIsLoading(false); // Hide loader
    }
  };
  
  // const GetBarChartDetails = async () => {
  //    ;
  //   showLoader();
  //   const requestparam = {
  //     MemberId: context.MemberId,
  //     IsAdmin: loggedInAs?.value === RoleEnum.Admin ? true : false,
  //     TotalApplications: TotalApplications,
  //   };
  //   const settlementBarChartData = await APICall(
  //     GetBarGraphDetailsForSettlement,
  //     requestparam
  //   );
  //   if (settlementBarChartData.Data !== null) {
  //     // const months = settlementBarChartData.Data?.map((data) => data.Month);
  //     // initializeBarChart(months);
  //     const monthlyData = {};
  //     settlementBarChartData.Data?.forEach((data) => {
  //       const month = parseInt(data.Month); // Convert month to integer
  //       if (!monthlyData[month]) {
  //         monthlyData[month] = 0; // Initialize total for the month
  //       }
  //       monthlyData[month] +=  parseInt(data.TotalApplications); // Add TotalApplications for the month
  //     });
  //     debugger
  //     const months = Object.keys(monthlyData); // Extract months
  //     const totalApplications = Object.values(monthlyData); // Extract total TotalApplications
  //     let highestcount = settlementBarChartData.Data[0].HighestCount ;
  //     initializeBarChart(months, totalApplications,highestcount);
  //     hideLoader();
  //   }
  //   hideLoader();
  // };

  const initializeBarChart = (months = [], totalApplications = [], highestcount = 0) => {
    const monthLabels = [
      "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
    ];
  
    // Handle case when no data is available by rendering 0 for each month
    if (totalApplications.length === 0) {
      totalApplications = new Array(12).fill(0); // Default to 12 months with zero values
    }
  
    const chart = new CanvasJSReact.CanvasJS.Chart("BarContainer", {
      animationEnabled: true,
      theme: "light2",
      axisX: {
        title: "Months",
        interval: 1, // Show every month
      },
      axisY: {
        minimum: 0, // Set minimum value for Y-axis
        maximum: highestcount + 10 || 10, // Add buffer to highest count or default to 10
        interval: 1, // Set step value for Y-axis
      },
      data: [
        {
          type: "column",
          showInLegend: false,
          color: "#df874d", // Custom color
          dataPoints: monthLabels.map((label, index) => {
            // Find the total applications for the current month index (index + 1)
            const monthIndex = index + 1; // Actual month number
            return {
              y: totalApplications[months.indexOf(monthIndex.toString())] || 0, // Fetch the data or default to 0
              label: label,
            };
          }),
        },
      ],
    });
  
    chart.render();
  
    // Cleanup function to destroy the chart when necessary
    return () => {
      chart.destroy();
    };
  };
  



  // //Actual Bar chart Here
  // const initializeBarChart = (months, totalApplications,highestcount) => {
  //    ;
  //   const monthLabels = [
  //     "Jan",
  //     "Feb",
  //     "Mar",
  //     "Apr",
  //     "May",
  //     "Jun",
  //     "Jul",
  //     "Aug",
  //     "Sep",
  //     "Oct",
  //     "Nov",
  //     "Dec",
  //   ];
  //   const chart = new CanvasJSReact.CanvasJS.Chart("BarContainer", {
  //     animationEnabled: true,
  //     theme: "light2",
  //     title: {
  //       // text: "Top Oil Reserves",s
  //     },
  //     axisX: {
  //       title: "Months",
  //       interval: 1, // Show every label
  //     },
  //     axisY: {
  //       // title: "Reserves(MMbbl)",
  //       minimum: 0, // Set minimum value
  //       maximum: highestcount+10, // Set maximum value
  //       interval: 1, // Set step value
  //     },
  //     data: [
  //       {
  //         type: "column",
  //         showInLegend: false,
  //         legendMarkerColor: "grey",
  //         color: "#df874d",
  //         // legendText: "MMbbl = one million barrels",
  //         dataPoints: monthLabels?.map((label, index) => ({
  //           y: totalApplications[months.indexOf(String(index + 1))] || 0,
  //           label: label,
            
  //         })),
  //       },
  //     ],
  //   });
  //   chart.render();

  //   // Cleanup function to destroy the chart when the component unmounts
  //   return () => {
  //     chart.destroy();
  //   };
  // };

  useEffect(() => {
    // SettlementRequestChart();
    // initializeBarChart();
    // LoanRequestChart();
    getMultipleDropdownData();
    // GetBarChartDetails();
  }, []);

  useEffect(() => {
    // Ensure typeofApplicant is valid before fetching
    if (typeofApplicant) {
      GetBarChartDetails();
    }
  }, [typeofApplicant]);

  // useEffect(() => {
  //   GetBarChartDetails();
  // }, [typeofApplicant]);

  useEffect(() => {
    GetLoanRequestChartDetails(loanYear.label, loaMonth.label);
  }, [loanYear, loaMonth]);

  useEffect(() => {
    LoanRequestChart();
  }, [pendingLoan, rejectedLoan, approvedLoan]);

  useEffect(() => {
    SettlementRequestChart();
  }, [pendingSettlement, rejectedSettlement, approvedSettlement]);

  useEffect(() => {
    GetSettlementRequestChartDetails(
      settlementYear.label,
      settlementMonth.label
    );
  }, [settlementYear, settlementMonth]);

  const SettlementRequestChart = () => {
    console.log("loanfunction calling...");
    const chart = new CanvasJSReact.CanvasJS.Chart("PieContainer", {
      animationEnabled: true,
      title: {
        // text: "Settlement Request",
        horizontalAlign: "left",
      },
      // subtitles: [{
      // 	text: "71% total",
      // 	verticalAlign: "center",
      // 	fontSize: 24,
      // 	dockInsidePlotArea: true
      // }],
      data: [
        {
          type: "doughnut",
          startAngle: 60,
          //innerRadius: 60,
          indexLabelFontSize: 17,
          indexLabel: "{label} - #percent%",
          toolTipContent: "<b>{label}:</b> {y} (#percent%)",
          dataPoints: [
            { y: pendingSettlement, label: "Pending" },
            { y: rejectedSettlement, label: "Rejected" },
            { y: approvedSettlement, label: "Accepted" },
          ],
        },
      ],
    });
    chart.render();
    // Cleanup function to destroy the chart when the component unmounts
    // return () => {
    //   chart.destroy();
    // };
  };

  const LoanRequestChart = () => {
    const chart = new CanvasJSReact.CanvasJS.Chart("LoanReqContainer", {
      animationEnabled: true,
      title: {
        // text: "Loan Request",
        horizontalAlign: "left",
      },
      data: [
        {
          type: "doughnut",
          startAngle: 60,
          //innerRadius: 60,
          indexLabelFontSize: 17,
          indexLabel: "{label} - #percent%",
          toolTipContent: "<b>{label}:</b> {y} (#percent%)",

          dataPoints: [
            { y: pendingLoan, label: "Pending" },
            { y: rejectedLoan, label: "Rejected" },
            { y: approvedLoan, label: "Accepted" },
          ],
        },
      ],
    });
    chart.render();
    // Cleanup function to destroy the chart when the component unmounts
    return () => {
      chart.destroy();
    };
  };

  const selectOnChange = (event: any, field: any) => {
    // showLoader();
    if (field === "settlementMonth") {
      setSettlementMonth(event);
    }
    if (field === "settlementYear") {
      setSettlementYear(event);
    }

    if (field === "LoanMonth") {
      setLoaMonth(event);
    }
    if (field === "LoanYear") {
      setLoanYear(event);
    }

    if (field === "typeOfApplication") {
      if (event?.code) {
        setTotalApplications(event.code);
      } else {
        setTotalApplications("");
      }
      setTypeofApplicant(event);
      // if (typeofApplicant?.value == 1) {
      //   setJanData(100);
      //   setFebData(200);
      //   setMarchData(85);
      //   setAprilData(64);
      //   setMayData(120);
      //   setMayData(65);
      //   setJuneData(250);
      //   setJulyata(350);
      //   setAugData(280);
      //   setSepData(400);
      //   setOctData(300);
      //   setNevData(200);
      //   setDecData(350);
      // } else {
      //   setJanData(150);
      //   setFebData(200);
      //   setMarchData(185);
      //   setAprilData(64);
      //   setMayData(120);
      //   setMayData(65);
      //   setJuneData(250);
      //   setJulyata(350);
      //   setAugData(280);
      //   setSepData(300);
      //   setOctData(300);
      //   setNevData(50);
      //   setDecData(250);
      // }
      // initializeBarChart();
    }
    // hideLoader();
  };


  // <div className="row d-flex flex-row justify-content-end align-items-center flex-wrap">
  //       <div className="row drop_appl">
  //         <div className="col-lg-12 col-sm-12 col-xs-12 label_appl">
  //           <label>Type of Application</label>

  //           <SelectForm
  //             className="selecter"
  //             options={typeofApplicantOptions}
  //             isMulti={false}
  //             placeholder={""}
  //             value={typeofApplicant}
  //             isDisabled={false}
  //             onChange={(event: any) =>
  //               selectOnChange(event, "typeOfApplication")
  //             }
  //           />
  //         </div>
  //       </div>
  //       <div id="BarContainer" style={{ height: 300, width: "100%" }}></div>
  //     </div>

  return (
    <div className="">

<div className="row d-flex flex-row justify-content-end align-items-center flex-wrap">
        <div className="row drop_appl">
          <div className="col-lg-12 col-sm-12 col-xs-12 label_appl">
            <label>Type of Application</label>

            <SelectForm
              className="selecter"
              options={typeofApplicantOptions}
              isMulti={false}
              placeholder={""}
              value={typeofApplicant}
              isDisabled={false}
              onChange={(event: any) =>
                selectOnChange(event, "typeOfApplication")
              }
            />
          </div>
        </div>
        <div id="BarContainer" style={{ height: 300, width: "100%" }}></div>
      </div>
      

      <div className="row mt-5 d-flex flex-row justify-content-end align-items-center flex-wrap">
        <div className="col-lg-6">
          <div className="col-lg-12">
            <h3>Settlement Request</h3>
          </div>
          <div className="row drop_cont">
            <div className="col-lg-4 col-sm-4 col-xs-4 label_drop">
              <label>Month</label>
              <SelectForm
                className="selecter"
                options={monthOption}
                isMulti={false}
                placeholder={""}
                value={settlementMonth}
                isDisabled={false}
                onChange={(event: any) =>
                  selectOnChange(event, "settlementMonth")
                }
              />
            </div>

            <div className="col-lg-4 col-sm-4 col-xs-4 label_drop">
              <label>Year</label>
              <SelectForm
                className="selecter"
                options={yearOption}
                isMulti={false}
                placeholder={""}
                value={settlementYear}
                isDisabled={false}
                onChange={(event: any) =>
                  selectOnChange(event, "settlementYear")
                }
              />
            </div>
          </div>
          <div id="PieContainer" style={{ height: 300, width: "100%" }}></div>
          {!stlmtdataAvailable && (
            <div className="stmltData_NotAvailable"> No Details Available</div>
          )}
          {/* <SettlementRequest /> */}
        </div>
        <div className="col-lg-6">
          <div className="col-lg-12">
            <h3>Loan Request</h3>
          </div>
          <div className="row  drop_cont">
            <div className="col-lg-4 col-sm-4 col-xs-4 label_drop ">
              <label>Month</label>
              <SelectForm
                className="selecter"
                options={monthOption}
                isMulti={false}
                placeholder={""}
                value={loaMonth}
                isDisabled={false}
                onChange={(event: any) => selectOnChange(event, "LoanMonth")}
              />
            </div>

            <div className="col-lg-4 col-sm-4 col-xs-4 label_drop">
              <label>Year</label>
              <SelectForm
                className="selecter"
                options={yearOption}
                isMulti={false}
                placeholder={""}
                value={loanYear}
                isDisabled={false}
                onChange={(event: any) => selectOnChange(event, "LoanYear")}
              />
            </div>
          </div>

          <div
            id="LoanReqContainer"
            style={{ height: 300, width: "100%" }}
          ></div>
          {!loandataAvailable && (
            <div className="LoanData_NotAvailable"> No Details Available</div>
          )}
          {/* <SettlementRequest /> */}
        </div>
      </div>
    </div>
  );
};

export default InnerSettlementRequest;
